import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {createClient, fetchClientById, fetchCustomerClients, updateClient} from "../API/api";
import Moment from "moment/moment";
import {getQuotes} from "./ProjectsSlice";

export const getCustomerClients = createAsyncThunk(
    'customerClients/getCustomerClients',
    async (_,{ rejectWithValue }) => {
        try {
            const response = await fetchCustomerClients();
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

export const getClientById = createAsyncThunk(
    'customerClients/getClientById',
    async (id, { rejectWithValue }) => {
        try {
            const response = await fetchClientById(id);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

export const postClient = createAsyncThunk(
    "customerClients/createClient",
    async (client, { rejectWithValue }) => {
        try {
            const response = await createClient(client);
            return response.data;

        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

export const putClient = createAsyncThunk(
    "customerClients/updateClient",
    async (client, { dispatch, rejectWithValue }) => {
        try {
            const response = await updateClient(client.id, client.payload);
            dispatch(getQuotes());
            return response.data;

        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

const customerClientsSlice = createSlice({
    name: "customerClients",
    initialState: {
        getClients: {
            status: 'idle',
            error: null,
            array: [],
            byId: {},
            allIds: []
        },
        getClientById: {
            status: 'idle',
            clientsById: {},
            error: null
        },
        putClient: {
            status: 'idle',
            error: null
        },
        postNewClient: {
            status: 'idle',
            error: null
        },
    },
    reducers: { },
    extraReducers: (builder) => {
        builder
            // Get All Clients
            .addCase(getCustomerClients.pending, (state) => {
                state.getClients.status = 'loading';
            })
            .addCase(getCustomerClients.fulfilled, (state, action) => {
                state.getClients.status = 'succeeded';
                state.getClients.array = action.payload.clients.map(client => ({
                    ...client,
                    createdAt: Moment(client.createdAt).format('D MMM YYYY, h:mma')
                }));
                action.payload.clients.forEach(customerClient => {
                    state.getClients.byId[customerClient.id] = customerClient;
                    state.getClients.allIds.push(customerClient.id);
                });
            })
            .addCase(getCustomerClients.rejected, (state, action) => {
                state.getClients.status = 'failed';
                state.getClients.error = action.error.message;
            })
            // Get Client by Id
            .addCase(getClientById.pending, (state) => {
                state.getClientById.status = 'loading';
            })
            .addCase(getClientById.fulfilled, (state, action) => {
                state.getClientById.status = 'succeeded';
                state.getClientById.clientsById[action.payload.id] = action.payload;
            })
            .addCase(getClientById.rejected, (state, action) => {
                state.getClientById.status = 'failed';
                state.getClientById.error = action.error.message;
            })
            // Create Client
            .addCase(postClient.pending, (state) => {
                state.postNewClient.status = 'loading';
            })
            .addCase(postClient.fulfilled, (state, action) => {
                state.postNewClient.status = 'succeeded';
                state.getClients.byId[action.payload.clientId] =
                    {
                        id: action.payload.clientId,
                        ...action.meta.arg
                    };
                state.getClients.allIds.push(action.payload.clientId);
                state.getClients.array.push({
                    id: action.payload.clientId,
                    ...action.meta.arg
                });
            })
            .addCase(postClient.rejected, (state, action) => {
                state.postNewClient.status = 'failed';
                state.postNewClient.error = action.error.message;
            })
            // Update Client
            .addCase(putClient.pending, (state, action) => {
                state.putClient.status = 'loading';
            })
            .addCase(putClient.fulfilled, (state, action) => {
                state.putClient.status = 'succeeded';
                const responseToSet = {
                    ...action.payload,
                    createdAt: Moment(action.payload.createdAt).format('D MMM YYYY, h:mma'),
                    lastModifiedAt: Moment(action.payload.lastModifiedAt).format('D MMM YYYY, h:mma')
                };
                state.getClients.byId[action.payload.id] = responseToSet;
                state.getClientById.clientsById[action.payload.id] = responseToSet;
                const clientIndex = state.getClients.array.findIndex(x => x.id === action.payload.id);
                if (clientIndex !== -1) {
                    state.getClients.array[clientIndex] = responseToSet;
                }
            })
            .addCase(putClient.rejected, (state, action) => {
                state.putClient.status = 'failed';
                state.putClient.error = action.error.message;
            })
    }
});

export const getClientsAllIds = (state) => state.customerClients.getClients.allIds;

export const getClientsArray = (state) => state.customerClients.getClients.array;
export const getAllClientsById = (state) => state.customerClients.getClients.byId;
export const getClientsStatus = (state) => state.customerClients.getClients.status;
export const getClientsError = (state) => state.customerClients.getClients.error;

export const getClientByIdIds = (state) => state.customerClients.getClientById.clientsById;
export default customerClientsSlice.reducer;